module.exports = __webpack_public_path__ + "img/close-x.a93f0bf5.svg";